import * as React from "react";
const SvgFiRrFaceSleepy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-sleepy_svg__a)">
      <path
        fill="#062147"
        d="M8.197 18.592a1 1 0 0 1 .205-1.395c.066-.049 1.632-1.198 3.598-1.198s3.531 1.149 3.598 1.198a1 1 0 0 1-1.196 1.604c-.007-.005-1.113-.802-2.402-.802s-2.396.797-2.406.805a1 1 0 0 1-1.396-.212zm9.68-3.55c-.557-.207-1.082.389-.797.911.432.791.902 2.428.919 3.94.012 1.031.739 1.975 1.763 2.093A2 2 0 0 0 22 20c0-2.473-2.372-4.306-4.123-4.958m.807-4.798a1 1 0 0 0-1.411.1c-.349.402-.845.652-1.295.652h-.007c-.424-.002-.82-.219-1.179-.643a1 1 0 1 0-1.527 1.292c.938 1.108 1.982 1.346 2.693 1.351h.02c1.029 0 2.077-.5 2.807-1.341a1 1 0 0 0-.101-1.411m-8 0a1 1 0 0 0-1.411.1c-.351.404-.854.69-1.302.652-.424-.002-.82-.219-1.179-.643a1 1 0 1 0-1.527 1.292c.938 1.108 1.982 1.346 2.693 1.351h.02c1.029 0 2.077-.5 2.807-1.341a1 1 0 0 0-.101-1.411M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12c1.506 0 2.975-.275 4.364-.819a1 1 0 1 0-.729-1.862 10 10 0 0 1-3.636.681c-5.514 0-10-4.486-10-10S6.486 2 12 2s10 4.486 10 10c0 .611-.056 1.223-.165 1.819a1 1 0 0 0 1.967.361c.132-.715.198-1.449.198-2.181C24 5.383 18.617 0 12 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-sleepy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSleepy;
